{
  "placeholder": "Please enter {fieldName}",
  "email": "Email",
  "validEmail": "Email must be valid",
  "password": "Password",
  "validPassword": "Password must contain at least 8 characters, including 1 uppercase, 1 lowercase, 1 number and 1 special character",
  "passwordsDontMatch": "Passwords do not match",
  "newPassword": "New Password",
  "confirmPassword": "Confirm Password",
  "confirmPasswordPlaceholder": "Please confirm Password",
  "confirmNewPassword": "Confirm New Password",
  "confirmNewPasswordPlaceholder": "Please confirm New Password",
  "oldPassword": "Old Password",
  "verificationCode": "Verification Code",
  "validVerificationCode": "Verification Code must be 6 numbers",
  "verificationCodeRequired": "Verification Code is required",
  "name": "Name",
  "surname": "Surname",
  "telNumber": "Telephone Number",
  "mobileNumber": "Mobile Number",
  "countryRegion": "Country / Region",
  "validPhoneNumber": "Please enter a valid phone number",
  "submit": "Submit",
  "update": "Update",
  "submitVerificationCode": "Submit Verification Code",
  "csvInvalid": "One of these comma separated URLs is invalid",
  "selectDatetime": "Select date/time",
  "asap": "ASAP",
  "selectAddress": "Select Address",
  "searchPostcodeOrAddress": "Search postcode or address",
  "filterNicknameOrAddress": "Filter nickname or address",
  "searchFor": "Search for {label}",
  "select": "Select {label}",
  "toPayment": "Go to payment",
  "addressForm": {
    "addAddress": "Add address",
    "editAddress": "Edit address",
    "labels": {
      "code": "Nickname",
      "addressName": "Company/Address Name",
      "address1": "Address Line 1",
      "address2": "Address Line 2",
      "address3": "Town/City",
      "address4": "County",
      "postcode": "Postcode",
      "notes": "Notes"
    },
    "placeholders": {
      "code": "Example: HQ",
      "addressName": "Example: Example Solutions Ltd",
      "address1": "Example: 123 Example Street",
      "address2": "Example: Innovation Park",
      "address3": "Example: London",
      "address4": "Example: Greater London",
      "postcode": "Example: SW1A 1AA",
      "notes": "Example: Primary office address"
    },
    "useAsDefault": "Use as default",
    "submitInsert": "Add",
    "submitUpdate": "Update",
    "deleteAddress": "Delete",
    "deleteAddressAlert": "Delete this address?",
    "insertSuccessToast": "Address added",
    "insertFailToast": "Unable to add address",
    "editSuccessToast": "Address updated",
    "editFailToast": "Unable to update address",
    "deleteSuccessToast": "Address deleted",
    "deleteFailToast": "Unable to delete address"
  },
  "format": "Format: {formats} | Formats: {formats}",
  "isRequired": "{fieldName} is required",
  "mustBeWholeNum": "{fieldName} must be a whole number",
  "mustBeNum": "{fieldName} must be a number",
  "mustBeTwoDecimalPlaces": "{fieldName} must have 2 digits after decimal or less",
  "equalTo": "Equal to",
  "equalGreaterThan": "Equal/Greater than",
  "equalLessThan": "Equal/Less than",
  "greaterThan": "Greater than",
  "lessThan": "Less than",
  "isNull": "Is null",
  "isNotNull": "Is not null",
  "isOneOf": "Is one of",
  "isNotOneOf": "Is not one of",
  "between": "Between",
  "contains": "Contains",
  "flightDate": "Flight Date",
  "flightNumber": "Flight Number",
  "holdOff": "Hold Off",
  "complete": "Complete {section}",
  "sendConfirmation": {
    "submit": "Send",
    "title": "Send Confirmation",
    "otherEmail": "Other email",
    "emailErrorText": "Please select or enter a valid email"
  },
  "tariff": {
    "viewOnlyMessage": "Please call us to book this service",
    "unavailableMessage": "Please select an available service",
    "unavailableRibbonMessage": "Call to Book",
    "bookMessage": "Book - {tariff}",
    "sortLabel": "Sort Tariffs By"
  },
  "stops": {
    "accordionHeader": "Details",
    "asDirectedLabel": "As Directed",
    "missingAddressStopMessage": "Missing Stop"
  },
  "vouchers": {
    "vouchersAddedCount": "1 voucher added | {count} vouchers added",
    "maxVouchersMessage": "Maximum of {maxVouchers} vouchers can be added",
    "addVoucherButton": "Add Voucher",
    "noVouchersMessage": "No vouchers added",
    "voucherNumber": "Voucher #{num}",
    "voucherCode": "Code: {voucherCode}",
    "enterVoucherCode": "Enter voucher code"
  },
  "arriveByAwaitingDetailsMessage": "Complete booking details to see arrival time",
  "goodButtons": {
    "copy": "Copy {good}",
    "remove": "Remove {good}",
    "add": "Add {good}"
  },
  "maxGoodsQtyMessage": "Total quantity of all goods cannot exceed {max}",
  "maxGoodsCartonsMessage": "Total unit cartons of all goods cannot exceed {max}",
  "quickQuoteBookingMessage": "In order to complete your booking please sign into or create a {app} account",
  "termsAndConditions": {
    "message": "By making this booking you agree to the",
    "link": "booking terms & conditions",
    "afterMessage": ""
  },
  "cancelBooking": {
    "submit": "Cancel",
    "otherReason": "Other reason",
    "message": "Please provide a reason",
    "reasonErrorText": "Please select or enter a valid cancellation reason"
  }
}
